// @flow
import styled from 'styled-components';

export const Card = styled.div`
  background-color: var(--color-neutral-white);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: var(--global-radius);
`;

export const CardBody = styled.div`
  padding: 32px 24px 16px;
  text-align: center;
`;

export const CardTitle = styled.h4`
  font-weight: bold;
  letter-spacing: -1px;
  font-size: 28px;
  margin-bottom: 0;
`;

export const CardLabel = styled.div`
  font-weight: 600;
  color: var(--color-base-font);
  margin-bottom: 16px;
`;

export const CardFooter = styled.div`
  border-top: 1px solid var(--boder-color);
  display: block;
  padding: 32px 24px;
  color: var(--color-base-font);
  text-decoration: none;
`;

export const CardPrice = styled.strong`
  color: var(--color-system-success);
  font-size: 28px;
  margin-bottom: 16px;
`;
